import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const oAuthService = inject(OAuthService);

  if (oAuthService.hasValidIdToken() && oAuthService.hasValidAccessToken()) {
    return true;
  }

  const interval = setInterval(() => {
    if (oAuthService.jwks == null) {return;}
    clearInterval(interval);
    oAuthService.initImplicitFlow(JSON.stringify({
      returnUrl: state.url,
    }));
  }, 100);

  return false;
};
